import { Grid } from '@mui/material'
import MapDetailCard from './MapDetailCard'
import { DetailInfoProps } from './MapSection'

function MapDetails({ details }: { details?: DetailInfoProps[] }) {

    const style = {};


    return (
        <Grid sx={style} container spacing={2}>

            {
                details && details.map((detail, i) => (
                    <Grid key={i} item md={12} xs={4}>
                        <MapDetailCard detail={detail}></MapDetailCard>
                    </Grid>
                ))
            }

        </Grid>
    )
}

export default MapDetails